// client/src/pages/landingpages/lpService.js
import { apiFetch } from '../../api/api';

const BASE = '/landingpages';

// Prefer new GET /landingpages/get/:id, fallback to legacy
export async function getLandingPageById(id) {
  try {
    return await apiFetch(`${BASE}/get/${id}`, { method: 'GET' });
  } catch {
    return await apiFetch(`${BASE}/getById/${id}`, { method: 'GET' });
  }
}

export const createLandingPage = (payload) =>
  apiFetch(`${BASE}/create`, { method: 'POST', body: payload });

export const updateLandingPage = (id, payload) =>
  apiFetch(`${BASE}/update/${id}`, { method: 'POST', body: payload });

export const removeLandingPage = (id) =>
  apiFetch(`${BASE}/remove/${id}`, { method: 'DELETE' });

// ---- Helpers (Datasets/Cards) ----

// Datasets for current org. Try legacy GET, then POST /datasets/list -> {items, total}
export async function getDataSets() {
  try {
    return await apiFetch('/datasets/getDataSets', { method: 'GET' });
  } catch {
    const data = await apiFetch('/datasets/list', {
      method: 'POST',
      body: { cnt: 0, lmt: 200, sortBy: 'updatedAt', sortOrder: 'desc' },
    });
    return Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
  }
}

// Cards (designs) for current org (server should filter by X-Org-Id)
export const getAllCards = () =>
  apiFetch('/cards/getAll', { method: 'GET' });
